export default __webpack_public_path__ + "static/media/pharmaceuticals.25ea2de3.png";